import { ReactNode, useEffect, useState } from 'react';
import styles from './TabContainer.module.css';

const TabContainer: React.FC<{
    currentTab?: React.ReactNode;
    tabs: React.ReactNode[];
    children: ReactNode;
    onChange: (index: number) => void;
}> = ({ currentTab, tabs, children, onChange }) => {
    const handleHeaderClick = (tabIndex: number) => {
        onChange(tabIndex);
    };

    if (currentTab === 'Unknown') {
        return children;
    }

    return (
        <div className={styles.container}>
            <div className={styles.tabs}>
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        className={`${
                            (currentTab as any)[0].key === (tab as any)[0].key
                                ? styles.active
                                : ''
                        } ${styles.tab}`}
                        onClick={() => handleHeaderClick(index)}
                    >
                        {tab}
                    </button>
                ))}
            </div>
            <div className={styles.content}>{children}</div>
        </div>
    );
};

export default TabContainer;
